import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  openSideBar: true,
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setOpenSideBar: (state) => {
      state.openSideBar = !state.openSideBar;
    },
    openSideBarState: (state) => {
      state.openSideBar = true;
    },
    closeSideBarState: (state) => {
      state.openSideBar = false;
    },
  },
});
export const { setOpenSideBar, openSideBarState, closeSideBarState } = appSlice.actions;
export default appSlice.reducer;
